import { useQuery } from 'react-query';

import { getFrequentPassageStickerTypes } from '../../../services/api/frequentPassageStickerTypes';
import {
  FrequentPassageRequest,
  FrequentPassageStickerType,
  Material,
  MaterialRequest,
  Options,
  QueryListResult,
} from '../utils/types';

export const FREQUENT_PASSAGE_STICKER_TYPES_ALL_QUERY_KEY = 'Q_FREQUENT_PASSAGE_STICKER_TYPES_ALL';
export type UseFrequentPassageStickerTypesOptions = Options;

export const useFrequentPassageStickerTypes = (
  eventId: number,
  options: UseFrequentPassageStickerTypesOptions = {}
) => {
  let { page, size, sort, include, ...rest } = options;

  if (!page) page = 0;
  if (!size) size = 50;
  if (!sort) sort = '-created_at';

  const filters = {
    'page[number]': page,
    'page[size]': size,
    sort,
    include,
    'filter[event_id]': eventId,
    ...rest,
  };
  return useQuery<QueryListResult<FrequentPassageStickerType>>(
    [FREQUENT_PASSAGE_STICKER_TYPES_ALL_QUERY_KEY, eventId, page, size, sort, include],
    () => getFrequentPassageStickerTypes(filters)
  );
};
